<template>
  <MysteryButton
    v-if="isMysteryButton"
    :color="buttonThemeVariation === 2 ? 'purple' : 'black'"
    :disabled="disabled"
    class="word-tracking-button"
    type="box"
    @click="$emit('click')"
  >
    <span class="word-tracking-button__icon-with-text">
      <NebulaIcon
        v-if="!wordTrackingActive"
        symbol-id="pointer"
        size="s"
      />
      <span>{{ buttonText }}</span>
    </span>
  </MysteryButton>
  <NebulaButton
    v-else
    :class="themeClass"
    :is-disabled="disabled"
    :disabled="disabled"
    class="word-tracking-button"
    @click="$emit('click')"
  >
    <template #badgeWithText>
      <span class="word-tracking-button__icon-with-text">
        <NebulaIcon
          v-if="!wordTrackingActive"
          symbol-id="pointer"
          size="s"
        />
        <span>{{ buttonText }}</span>
      </span>
    </template>
  </NebulaButton>
</template>

<script>
import { mapState } from 'pinia';
import { get } from 'lodash-es';
import { NebulaButton, NebulaIcon } from '@discoveryedu/nebula-components';
import { MysteryButton } from '@discoveryedu/mystery-components';
import {
  useEditorStore,
} from '@/stores';

export default {
  name: 'WordTrackingButton',
  components: {
    MysteryButton,
    NebulaButton,
    NebulaIcon,
  },
  props: {
    wordTracking: {
      type: Object,
      required: true,
    },
    wordTrackingActive: {
      type: Boolean,
      default: false,
    },
    isMysteryButton: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: Object,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click'],
  computed: {
    ...mapState(useEditorStore, [
      'currentPage',
    ]),
    buttonText() {
      return this.wordTrackingActive ? this.$t('Next Word') : this.$t('Start Word Tracking');
    },
    buttonThemeVariation() {
      /*
        Make sure that the button color variation in the exists in the theme.
        If not, default to the first.
      */
      const defaultVariation = 1;
      const variation = get(this, 'wordTracking.button_theme.variation', defaultVariation);
      const hasButtonColor = !!(this.theme?.buttonColors || []).find((c) => c.id === variation);
      return hasButtonColor ? variation : defaultVariation;
    },
    themeClass() {
      return `editor-theme__button--${this.buttonThemeVariation}`;
    },
  },
};
</script>

<style lang="stylus">
.word-tracking-button {
  min-width: 220px;

  &__icon-with-text {
    align-items: center;
    display: flex;
    flex-direction: column;
    height: 42px;
    justify-content: center;

    svg {
      margin-bottom: $nebula-space-1x;
    }
  }

  .nebula-button__badge-with-text {
    width: 100%;
  }
}
</style>
